module.exports = __webpack_public_path__ + "img/shop-title.e31d030b.png";